import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const ENT_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.diagnosisLabel,
  },
  {
    key: "secondary_diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.secondaryDiagnoses,
  },
  {
    key: "therapy",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.therapyLabel,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.medicalHistoryLabel,
  },
  {
    key: "admission_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.medicationUponAdmission,
  },
  {
    key: "findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.findingsLabel,
  },
  {
    key: "additional_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.futherFindingsLabel,
  },
  {
    key: "laboratory_parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.laboratoryParameters,
  },
  {
    key: "clinical_course",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.historyLabel,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.dischargeMedicationLabel,
  },
  {
    key: "recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formEnt.recommendation,
  },
];

export function createEntDischargeLetterPdf(
  props: PdfCreatorProps<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT>,
) {
  return createDischargeLetterPdf<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT>(
    props,
    ENT_FIELD_CONFIG,
  );
}
